import React from 'react';
import CarCard from './CarCard';
import { cars } from '../data/cars';
import {
  formatInstallmentLabel,
  getEstimatedInstallmentForCar,
  parsePrice,
} from '../utils/loanCalculator';

const META2_BY_ID = {
  traz: 'New Car',
  axia: '1.0L Engine',
  myvi: 'King of Road',
  alza: '7 Seater',
  ativa: '5 Seater',
  aruz: '7 Seater',
  bezza: '5 Seater',
};

const ModelsSection = () => {
  const displayCars = cars.map((car) => {
    const lowestPrice = getEstimatedInstallmentForCar(car);
    const priceFrom =
      car.price ||
      (car.variants?.[0]?.price
        ? `RM ${parsePrice(car.variants[0].price).toLocaleString('en-MY')}`
        : '');

    return {
      title: `Perodua ${car.name}`,
      price: priceFrom.startsWith('From') ? priceFrom : `From ${priceFrom}`,
      meta1: `Est. ${formatInstallmentLabel(lowestPrice)}`,
      meta2: META2_BY_ID[car.id] || car.category || '',
      image: car.image,
    };
  });

  return (
    <section id="models" className="section">
      <h2 className="section-title">Latest Models & Promos</h2>
      <div className="models-grid">
        {displayCars.map((car, index) => (
          <CarCard key={index} car={car} />
        ))}
      </div>
    </section>
  );
};

export default ModelsSection;
